export default function FAQ() {
  return (
    <section className="max-w-3xl mx-auto px-6 py-16">
      <h2 className="text-4xl font-bold text-blue-600 mb-10 text-center">
        Frequently Asked Questions
      </h2>

      <div className="space-y-4">
        <details className="group border rounded-lg p-4 bg-white shadow-sm">
          <summary className="cursor-pointer text-lg font-semibold text-gray-800 flex justify-between items-center">
            Is Popalooza free?
            <span className="ml-2 text-blue-600 group-open:rotate-180 transition-transform">▼</span>
          </summary>
          <p className="mt-2 text-gray-700">
            Yes! Popalooza is free to download and play.
          </p>
        </details>

        <details className="group border rounded-lg p-4 bg-white shadow-sm">
          <summary className="cursor-pointer text-lg font-semibold text-gray-800 flex justify-between items-center">
            Does Popalooza have ads?
            <span className="ml-2 text-blue-600 group-open:rotate-180 transition-transform">▼</span>
          </summary>
          <p className="mt-2 text-gray-700">
            Yes, but ads are gentle and milestone‑based to avoid interrupting gameplay.
          </p>
        </details>

        <details className="group border rounded-lg p-4 bg-white shadow-sm">
          <summary className="cursor-pointer text-lg font-semibold text-gray-800 flex justify-between items-center">
            Is Popalooza safe for kids?
            <span className="ml-2 text-blue-600 group-open:rotate-180 transition-transform">▼</span>
          </summary>
          <p className="mt-2 text-gray-700">
            Absolutely. Popalooza is designed with family‑friendly content.
          </p>
        </details>

        <details className="group border rounded-lg p-4 bg-white shadow-sm">
          <summary className="cursor-pointer text-lg font-semibold text-gray-800 flex justify-between items-center">
            Which devices are supported?
            <span className="ml-2 text-blue-600 group-open:rotate-180 transition-transform">▼</span>
          </summary>
          <p className="mt-2 text-gray-700">
            Most Android devices running Android 7.0 and above.
          </p>
        </details>
      </div>
    </section>
  );
}
